import { render, staticRenderFns } from "./deep-link.vue?vue&type=template&id=ef45c588&"
import script from "./deep-link.vue?vue&type=script&lang=js&"
export * from "./deep-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports